import { render, staticRenderFns } from "./addSolidityContract.vue?vue&type=template&id=2cc2c67f&scoped=true&"
import script from "./addSolidityContract.vue?vue&type=script&lang=js&"
export * from "./addSolidityContract.vue?vue&type=script&lang=js&"
import style0 from "./addSolidityContract.vue?vue&type=style&index=0&id=2cc2c67f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc2c67f",
  null
  
)

export default component.exports